var _circle, _circle2, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndoorCeremonySpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.61084,
    cy: 3.81396,
    r: 2.18896,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8784,
    cy: 3.81396,
    r: 2.18896,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17578 5.28516C5.17578 5.28516 8.84586 9.57856 15.1583 9.57856C21.4708 9.57856 25.1409 5.28516 25.1409 5.28516",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 9.2207C2.3125 8.66842 2.76022 8.2207 3.3125 8.2207H3.95496C4.50724 8.2207 4.95496 8.66842 4.95496 9.2207V21.4336H2.3125V9.2207Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5586 9.2207C25.5586 8.66842 26.0063 8.2207 26.5586 8.2207H27.201C27.7533 8.2207 28.201 8.66842 28.201 9.2207V21.4336H25.5586V9.2207Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.6895,
    y: 21.4336,
    width: 4.37805,
    height: 2.42188,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.44531,
    y: 21.4336,
    width: 4.37805,
    height: 2.42188,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 5.80664V8.34375",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 5.80664V8.34375",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8237 15.7508C11.8533 15.642 11.9521 15.5664 12.065 15.5664H18.3657C18.4776 15.5664 18.5759 15.6408 18.6063 15.7485L20.8748 23.7876C20.9198 23.9471 20.8 24.1055 20.6342 24.1055H9.88029C9.71554 24.1055 9.59584 23.9489 9.63904 23.7899L11.8237 15.7508Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCeremonySpace);
export default __webpack_public_path__ + "static/media/IndoorCeremonySpace.43d1d7ec92a4788dc2b33f1a24b21213.svg";
export { ForwardRef as ReactComponent };